import styled from 'styled-components';

import colors from '@theme/colors';

const FieldError = styled.span`
  display: block;
  font-family: GTAmerica;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: 2.75px;
  color: ${colors['error-red']};
`;

export default FieldError;
